<div class="app-employee-sidebar-header">
  <div class="app-employee-sidebar-header-title" [kitText]="titleText"></div>
  <kit-bs-button [kitModel]="addEmployeeAction" class="app-employee-sidebar-header-action"></kit-bs-button>
  <kit-bs-button [kitModel]="removeEmployeeAction" class="app-employee-sidebar-header-action"></kit-bs-button>
</div>
<div class="app-employee-sidebar-items list-group list-group-flush">
  <button *ngFor="let item of employeeActionList" [kitModel]="item" type="button"
          class="list-group-item list-group-item-action">
  </button>
</div>
